import React from "react";
import StaffRegistrationFormFull from "../../components/forms/StaffRegistrationFormFull";
import { db } from "../../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../context/AuthContext";
import { getUserDocId } from "../../utils/userDocId";



export default function StaffRegistrationFullPage() {
  const { user } = useAuth();

  const handleSubmit = async (data) => {
    const userId = getUserDocId(user);
    await setDoc(
      doc(db, "users", userId, "complianceDocs", "staffRegistrationFull"),
      {
        ...data,
        name: "Staff Registration Form (Full)",
        renewal: "As Required",
        status: "submitted",
        verified: false,
        lastUpdated: serverTimestamp(),
      },
      { merge: true }
    );

    alert("Full registration form submitted successfully!");
  };

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
      <StaffRegistrationFormFull onSubmit={handleSubmit} />
    </div>
  );
}
